import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";

export default function MarketingNav() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      data-testid="marketing-nav"
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#F9F8F6]/80 border-b border-[#E6E4DF]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="brand-logo">
          <div className="w-8 h-8 rounded-md bg-[#1C3F35] flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-[#F9F8F6]" strokeWidth={2.5} />
          </div>
          <span className="font-heading text-lg font-medium tracking-tight text-[#1A1A1A]">Beacon of Grants</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-[#1A1A1A]">
          <a href="/#features" className="hover:text-[#1C3F35] transition-colors" data-testid="nav-features">Features</a>
          <a href="/#how" className="hover:text-[#1C3F35] transition-colors" data-testid="nav-how">How it works</a>
          <Link to="/pricing" className="hover:text-[#1C3F35] transition-colors" data-testid="nav-pricing">Pricing</Link>
          <a href="/#testimonials" className="hover:text-[#1C3F35] transition-colors" data-testid="nav-testimonials">Customers</a>
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <Button
              onClick={() => navigate("/dashboard")}
              data-testid="cta-open-dashboard"
              className="bg-[#1C3F35] text-white hover:bg-[#1A362D] rounded-md"
            >
              Open Dashboard <ArrowRight className="w-4 h-4 ml-1" />
            </Button>
          ) : (
            <>
              <Link to="/login" data-testid="cta-login" className="text-sm text-[#1A1A1A] hover:text-[#1C3F35] transition-colors">
                Log in
              </Link>
              <Button
                onClick={() => navigate("/signup")}
                data-testid="cta-signup"
                className="bg-[#1C3F35] text-white hover:bg-[#1A362D] rounded-md"
              >
                Get started
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
